import React from 'react';
import Abnormality from './Abnormality';
import { validateFields } from '../../../shared/utils/handleBlowoutValidations';

const blowOutReasons = [
    {
        eventKey: 'Driver / Vehicle no show',
        label: 'Driver / Vehicle no show',
    },
    {
        eventKey: 'Incorrect size vehicle',
        label: 'Incorrect size vehicle',
    },
    {
        eventKey: 'Insufficient room',
        label: 'Insufficient room',
    },
    {
        eventKey: 'Other supplier packaging',
        label: 'Other supplier packaging',
    },
    {
        eventKey: 'Temporary Packaging',
        label: 'Temporary Packaging',
    },
    {
        eventKey: 'Unsafe load',
        label: 'Unsafe load',
    },
    {
        eventKey: 'Weight',
        label: 'Weight',
    },
    {
        eventKey: 'Others',
        label: 'Others',
    },
];

export default class BlowOut extends React.Component {
    render() {
        return (
            <Abnormality reasons={blowOutReasons} validations={validateFields} {...this.props} />
        );
    }
}
